export default "__VITE_ASSET__073910a7__"